import React, { useCallback, useRef } from "react";
import { KnowledgeCenter1, KnowledgeCenter2 } from "../../../assets/images";
import { IoCalendarOutline } from "react-icons/io5";
import { RxArrowTopRight } from "react-icons/rx";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import { formatDate } from "../../../utils/helper";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ImageFromJson from "../../../component/ImageFromJson";

const KnowledgeCenter = () => {
  var settings = {
    spaceBetween: 10,
    slidesPerView: 2,
  };
  const { getBlogList } = PublicService();
  const navigate = useNavigate();

  const pcosQuery = useQuery({
    queryKey: ["pcos"],
    queryFn: () => getBlogList({}),
  });
  const apiData = pcosQuery?.data?.data;

  const blogs = Array?.isArray(apiData)
    ? apiData
    : Array?.isArray(apiData?.content)
    ? apiData?.content
    : [];


  const blog1 = blogs?.[0];
  const blog2 = blogs?.[1];
  const blog3 = blogs?.[2];
  const blog4 = blogs?.[3];

  // console.log("blogs data", blogs);
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);
  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <>
      <div className="spacing">
        <div className="knowledge_center">
          <div className="container">
            <div className="page_title">
              <h2>Knowledge Center</h2>
              <p>
                Stay ahead with insights that matter. Explore our collection of
                expert blogs covering PCOS, Menopause, Endometriosis, and
                Postpartum - all designed to help you make smarter decisions and
                start your healing journey.
              </p>
            </div>
            <div className="item">
              <div className="knowledge_center_content">
                <Swiper
                  ref={sliderRef}
                  spaceBetween={10}
                  slidesPerView={2}
                  freeMode={true}
                  loop={true}
                  speed={2000}
                  navigation={{
                    nextEl: ".next-arrow",
                    prevEl: ".prev-arrow",
                    disabledClass: "swiper-button-disabled",
                  }}
                  watchSlidesVisibility={true}
                  autoHeight={true}
                  // breakpoints={{
                  //   576: {
                  //     width: 576,
                  //     slidesPerView: 1,
                  //   },
                  //   768: {
                  //     width: 768,
                  //     slidesPerView: 1,
                  //   },
                  // }}
                >
                  {blogs?.map((blog) => {
                    return (
                      <SwiperSlide key={blog.id}>
                        <div
                          className="content_right"
                          onClick={() => (window.location.href = blog?.link)}
                        >
                          <div className="image_wrap">
                            {/* <img
                              src={blog?.yoast_head_json?.og_image?.[0]?.url}
                              alt="feature-media"
                            /> */}
                            <ImageFromJson
                              apiUrl={
                                blog?._links?.["wp:featuredmedia"]?.[0]?.href
                              }
                            />
                          </div>
                          <p>
                            <IoCalendarOutline />
                            <span>{formatDate(blog?.date)}</span>
                          </p>
                          <h5>{blog?.title?.rendered}</h5>
                        </div>
                      </SwiperSlide>
                    );
                  })}

                  {/* <SwiperSlide>
                    <div
                      className="content_right"
                      onClick={() =>
                        navigate("/blog-details", { state: { blog: blog2 } })
                      }
                    >
                      <div className="image_wrap">
                        <img
                          src={
                            blog2?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.media_details?.sizes?.medium?.source_url
                              ? blog2._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.source_url
                              : blog2?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              ? blog2?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              : KnowledgeCenter2
                          }
                          alt="feature-media"
                        />
                      </div>
                      <p>
                        <IoCalendarOutline />
                        <span>{formatDate(blog2?.date)}</span>
                      </p>
                      <h5>{blog2?.title?.rendered}</h5>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className="content_right"
                      onClick={() =>
                        navigate("/blog-details", { state: { blog: blog3 } })
                      }
                    >
                      <div className="image_wrap">
                        <img
                          src={
                            blog3?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.media_details?.sizes?.medium?.source_url
                              ? blog3._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.source_url
                              : blog3?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              ? blog3?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              : KnowledgeCenter1
                          }
                          alt="feature-media"
                        />
                      </div>
                      <p>
                        <IoCalendarOutline />
                        <span>{formatDate(blog3?.date)}</span>
                      </p>
                      <h5>{blog3?.title?.rendered}</h5>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className="content_right"
                      onClick={() =>
                        navigate("/blog-details", { state: { blog: blog4 } })
                      }
                    >
                      <div className="image_wrap">
                        <img
                          src={
                            blog4?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.media_details?.sizes?.medium?.source_url
                              ? blog4._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.source_url
                              : blog4?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              ? blog4?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              : KnowledgeCenter2
                          }
                          alt="feature-media"
                        />
                      </div>
                      <p>
                        <IoCalendarOutline />
                        <span>{formatDate(blog4?.date)}</span>
                      </p>
                      <h5>{blog4?.title?.rendered}</h5>
                    </div>
                  </SwiperSlide> */}
                </Swiper>
                <button className="prev-arrow arrow" onClick={handlePrev}>
                  <IoIosArrowBack />
                </button>
                <button className="next-arrow arrow" onClick={handleNext}>
                  <IoIosArrowForward />
                </button>
              </div>
              <div className="button_wrap button_right">
                <Link to="https://holypills.in/blog/" target="blank">
                  All Knowledge Center <RxArrowTopRight />
                </Link>
              </div>
            </div>

            {/* <Slider {...settings}>
              <div className="item">
                <div className="knowledge_center_content">
                  <div
                    className="content_left"
                    onClick={() =>
                      navigate("/blog-details", { state: { blog: blog1 } })
                    }
                  >
                    <div className="image_wrap">
                      <img
                        src={
                          blog1?._embedded?.["wp:featuredmedia"]?.[0]
                            ?.media_details?.sizes?.medium?.source_url
                            ? blog1._embedded?.["wp:featuredmedia"]?.[0]
                                ?.source_url
                            : blog1?._embedded?.["wp:featuredmedia"]?.[0]
                                ?.media_details?.sizes?.full?.source_url
                            ? blog1?._embedded?.["wp:featuredmedia"]?.[0]
                                ?.media_details?.sizes?.full?.source_url
                            : KnowledgeCenter1
                        }
                        alt=""
                      />
                    </div>
                    <p>
                      <IoCalendarOutline />{" "}
                      <span>{formatDate(blog1?.date)}</span>
                    </p>
                    <h5>{blog1?.title?.rendered}</h5>
                  </div>
                  <div
                    className="content_right"
                    onClick={() =>
                      navigate("/blog-details", { state: { blog: blog2 } })
                    }
                  >
                    <div className="image_wrap">
                      <img
                        src={
                          blog2?._embedded?.["wp:featuredmedia"]?.[0]
                            ?.media_details?.sizes?.medium?.source_url
                            ? blog2._embedded?.["wp:featuredmedia"]?.[0]
                                ?.source_url
                            : blog2?._embedded?.["wp:featuredmedia"]?.[0]
                                ?.media_details?.sizes?.full?.source_url
                            ? blog2?._embedded?.["wp:featuredmedia"]?.[0]
                                ?.media_details?.sizes?.full?.source_url
                            : KnowledgeCenter2
                        }
                        alt=""
                      />
                    </div>
                    <p>
                      <IoCalendarOutline />{" "}
                      <span>{formatDate(blog2?.date)}</span>
                    </p>
                    <h5>{blog2?.title?.rendered}</h5>
                  </div>
                </div>
                <div className="button_wrap button_right">
                  <Link to="/knowledge-center">
                    All Knowledge Center <RxArrowTopRight />
                  </Link>
                </div>
              </div>
              {blog3 && blog4 && (
                <div className="item">
                  <div className="knowledge_center_content">
                    <div
                      className="content_left"
                      onClick={() =>
                        navigate("/blog-details", { state: { blog: blog3 } })
                      }
                    >
                      <div className="image_wrap">
                        <img
                          src={
                            blog3?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.media_details?.sizes?.medium?.source_url
                              ? blog3._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.source_url
                              : blog3?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              ? blog3?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              : KnowledgeCenter1
                          }
                          alt=""
                        />
                      </div>
                      <p>
                        <IoCalendarOutline />{" "}
                        <span>{formatDate(blog3?.date)}</span>
                      </p>
                      <h5>{blog3?.title?.rendered}</h5>
                    </div>
                    <div
                      className="content_right"
                      onClick={() =>
                        navigate("/blog-details", { state: { blog: blog4 } })
                      }
                    >
                      <div className="image_wrap">
                        <img
                          src={
                            blog4?._embedded?.["wp:featuredmedia"]?.[0]
                              ?.media_details?.sizes?.medium?.source_url
                              ? blog4._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.source_url
                              : blog4?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              ? blog4?._embedded?.["wp:featuredmedia"]?.[0]
                                  ?.media_details?.sizes?.full?.source_url
                              : KnowledgeCenter2
                          }
                          alt=""
                        />
                      </div>
                      <p>
                        <IoCalendarOutline />{" "}
                        <span>{formatDate(blog4?.date)}</span>
                      </p>
                      <h5>{blog4?.title?.rendered}</h5>
                    </div>
                  </div>
                  <div className="button_wrap button_right">
                    <Link to="/knowledge-center">
                      All Knowledge Center <RxArrowTopRight />
                    </Link>
                  </div>
                </div>
              )}
            </Slider> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default KnowledgeCenter;
